/*
 * Lazy autoplay for muted background videos.
 * Mark a <video> (or a wrapper around one) with data-lazy-autoplay and give it
 * preload="none" and no autoplay attribute. Nothing downloads until the video
 * is close to the viewport; it then plays, and pauses again when off screen.
 */
(function () {
  function getVideos() {
    var nodes = document.querySelectorAll('video[data-lazy-autoplay], [data-lazy-autoplay] video');
    return Array.prototype.slice.call(nodes);
  }

  function showPoster(video) {
    if (video.dataset.poster && !video.getAttribute('poster')) {
      video.setAttribute('poster', video.dataset.poster);
    }
  }

  function start(video) {
    showPoster(video);
    video.muted = true;
    if (video.preload !== 'auto') video.preload = 'auto';
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function init() {
    var videos = getVideos();
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start(entry.target);
          } else if (!entry.target.paused) {
            entry.target.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    videos.forEach(function (video) {
      if (video.dataset.lazyObserved) return;
      video.dataset.lazyObserved = 'true';
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
